<script>
</script>
<div class="document-body-loading">
  <div class="loading-spinner">
    <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path" /></svg>
    <div class="laoding-info">页面跳转中，请稍后...</div>
</div>
</div>
<style>
    .laoding-info {
        font-size: 12px;
        color: white;
        padding-top: 8px;
        letter-spacing: 2px;
    }
    .document-body-loading {
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    z-index: 2000;
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: opacity 0.3s;
  }
  .loading-spinner {
    top: 50%;
    margin-top: -21px;
    width: 100%;
    text-align: center;
    position: absolute;
  }
  .loading-spinner .circular {
    height: 42px;
    width: 42px;
    animation: loading-rotate 2s linear infinite;
  }
  .loading-spinner .path {
    animation: loading-dash 1.5s ease-in-out infinite;
    stroke-dasharray: 90,150;
    stroke-dashoffset: 0;
    stroke-width: 2;
    stroke: #409eff;
    stroke-linecap: round;
  }
  @keyframes loading-dash {
    0% {
        stroke-dasharray: 1,200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 90,150;
        stroke-dashoffset: -40px;
    }
    100% {
        stroke-dasharray: 90,150;
        stroke-dashoffset: -120px;
    }
  }
  @keyframes loading-rotate {
    100% {
      transform: rotate(1turn);
    }
  }
</style>
